import React from 'react'
import classNames from 'classnames'

function ResultsHeader({ children, modifierClasses = [] }) {
  const resultsHeaderClasses = classNames(
    'row',
    modifierClasses
  )

  return (
    <div className={resultsHeaderClasses}>
      {children}
    </div>
  )
}

export default ResultsHeader
